// @flow
import React from 'react';
import { translate } from 'react-i18next';
import styled, { withTheme } from 'styled-components';
import IncreaseDecreasePercent from 'statsradio/components/IncreaseDecreasePercent';
import { calculateMetricVariation, type MetricType, type Period } from '../../../domain/DashboardData';
import AudienceComparisonGraph from './AudienceComparisonGraph';

const GraphHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 2px;
`;

const Container = styled.div`
  padding-left: 20px;
`;

interface Props {
  metricType: MetricType;
  period: Period;
  comparedDataByTimeInterval: Object;
  t: any;
  theme: any;
}

function AudienceComparisonWeek({ metricType, period, comparedDataByTimeInterval, t, theme }: Props) {
  const variation = calculateMetricVariation(comparedDataByTimeInterval);
  const iconSize = { 'height': 24, 'width': 24 };
  return (
    <Container>
      <GraphHeader>
        <h3>{t('mondayToFriday')}</h3>
        <h4>
          <IncreaseDecreasePercent percent={variation} iconSize={iconSize} />
        </h4>
      </GraphHeader>
      <AudienceComparisonGraph comparedDataByTimeInterval={comparedDataByTimeInterval} period={period} metricType={metricType} />
    </Container>
  );
}

export default translate('dashboard')(withTheme(AudienceComparisonWeek));



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/audienceComparison/AudienceComparisonWeek.js